import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { CaseDetailPanelComponent } from './case-detail-panel.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { ComponentsModule as SharedComponentsModule } from 'src/app/shared/components/components.module';
import { CoreModule } from 'src/app/core/core.module';
import { AccountTransactionListModule } from 'src/app/ui/components/account-transactions/account-transaction-list/account-transaction-list.module';
import { CaseEditModalModule } from 'src/app/ui/components/cases/case-edit-modal/case-edit-modal.module';

@NgModule({
  declarations: [
    CaseDetailPanelComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbNavModule,
    PipesModule,
    CoreModule,
    SharedComponentsModule,
    AccountTransactionListModule,
    CaseEditModalModule
  ],
  exports: [
    CaseDetailPanelComponent
  ]
})
export class CaseDetailPanelModule { }
